import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoFreshworks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 161 48"
    {...props}
  >
    <g clipPath="url(#Logo_Freshworks_svg__a)">
      <path
        fill="#4D4D4D"
        d="M39.504 9.339c-4.017 0-5.427 2.793-5.427 5.4v1.596h-.851c-.612 0-1.09.479-1.09 1.09s.478 1.09 1.09 1.09h.851v11.013c0 .639.506 1.17 1.17 1.17.64 0 1.171-.505 1.171-1.17V18.516h2.58c.612 0 1.09-.479 1.09-1.09s-.478-1.091-1.09-1.091h-2.58v-1.596c0-1.463.532-3.192 3.112-3.192.612 0 1.09-.48 1.09-1.09-.026-.64-.505-1.118-1.116-1.118M48.548 15.96c-1.729 0-3.192.72-4.017 1.89v-.612c0-.639-.505-1.17-1.17-1.17-.638 0-1.17.505-1.17 1.17v12.289c0 .638.505 1.17 1.17 1.17.639 0 1.17-.505 1.17-1.17v-6.783c0-2.846 1.517-4.549 4.017-4.549.612 0 1.117-.505 1.117-1.117.027-.612-.478-1.117-1.117-1.117M62.78 22c0-.665-.107-2.394-1.118-3.83-1.037-1.49-2.66-2.262-4.868-2.262-4.096 0-6.437 2.713-6.437 7.448 0 4.895 2.34 7.502 6.73 7.502 2.953 0 4.575-1.463 4.868-1.756.186-.186.399-.426.399-.825 0-.585-.479-1.064-1.064-1.064-.293 0-.479.08-.665.213-.851.639-1.836 1.277-3.511 1.277-2.634 0-4.31-1.73-4.39-4.549h8.646c1.41-.026 1.41-1.303 1.41-2.154m-5.986-3.964c2.394 0 3.645 1.357 3.698 4.017h-7.74c.212-2.58 1.648-4.017 4.042-4.017M70.6 22.187c-1.73-.586-3.219-1.118-3.219-2.394 0-1.41 1.57-1.623 2.5-1.623 1.677 0 2.501.585 3.166 1.224.213.212.479.319.772.319.585 0 1.064-.479 1.064-1.064 0-.32-.133-.532-.24-.692-.984-1.303-2.66-2.022-4.761-2.022-2.98 0-4.815 1.49-4.815 3.858 0 2.899 2.554 3.777 4.788 4.522 1.703.585 3.165 1.064 3.165 2.314 0 1.702-1.888 1.968-3.032 1.968-1.543 0-2.74-.479-3.724-1.436a1.12 1.12 0 0 0-.798-.346c-.585 0-1.064.479-1.064 1.064 0 .24.08.426.266.692.878 1.117 2.873 2.26 5.32 2.26 3.352 0 5.347-1.569 5.347-4.176 0-2.82-2.5-3.697-4.735-4.468M84.405 15.909c-1.596 0-3.032.638-3.83 1.649V9.684c0-.638-.505-1.17-1.17-1.17-.639 0-1.17.505-1.17 1.17v19.87c0 .639.505 1.17 1.17 1.17.638 0 1.17-.505 1.17-1.17V22.08c0-2.687 1.303-4.043 3.83-4.043 2.448 0 3.458 1.117 3.458 3.83v7.687c0 .639.506 1.17 1.17 1.17.64 0 1.171-.505 1.171-1.17v-8.086c-.053-3.698-1.995-5.56-5.799-5.56M109.542 16.095c-.505 0-.904.292-1.091.771l-3.325 9.47-2.713-9.47c-.106-.372-.505-.771-1.09-.771s-.985.399-1.091.771l-2.713 9.443-3.325-9.47a1.12 1.12 0 0 0-1.09-.744c-.64 0-1.171.505-1.171 1.17 0 .16.026.32.106.479l4.442 12.21c.187.478.586.744 1.091.744a1.15 1.15 0 0 0 1.117-.824l2.607-8.965 2.607 8.965c.133.478.612.824 1.117.824s.904-.292 1.091-.771l4.442-12.21c.08-.16.106-.345.106-.505.027-.612-.478-1.117-1.117-1.117M118.001 15.908c-4.23 0-6.544 2.66-6.544 7.448 0 4.842 2.314 7.502 6.544 7.502s6.543-2.66 6.543-7.502c0-4.814-2.34-7.448-6.543-7.448m0 12.822c-2.82 0-4.203-1.756-4.203-5.347 0-3.538 1.41-5.32 4.203-5.32s4.203 1.782 4.203 5.32c0 3.59-1.384 5.347-4.203 5.347M133.536 15.96c-1.729 0-3.192.72-4.017 1.89v-.612c0-.639-.505-1.17-1.17-1.17-.639 0-1.171.505-1.171 1.17v12.289c0 .638.506 1.17 1.171 1.17.638 0 1.17-.505 1.17-1.17v-6.783c0-2.846 1.516-4.549 4.017-4.549.612 0 1.117-.505 1.117-1.117s-.505-1.117-1.117-1.117M142.367 22.027l4.815-3.858c.399-.319.452-.718.452-.93 0-.639-.505-1.17-1.17-1.17-.187 0-.506.026-.798.292l-6.837 5.586V9.684c0-.638-.505-1.17-1.17-1.17-.639 0-1.171.505-1.171 1.17v19.87c0 .639.506 1.17 1.171 1.17.638 0 1.17-.505 1.17-1.17v-4.788l1.623-1.303 5.24 6.73c.293.346.612.532.984.532.639 0 1.171-.506 1.171-1.17 0-.187-.027-.453-.24-.719zM155.481 22.187c-1.729-.586-3.218-1.118-3.218-2.394 0-1.41 1.569-1.623 2.5-1.623 1.676 0 2.5.585 3.165 1.224.213.212.479.319.772.319.585 0 1.064-.479 1.064-1.064 0-.346-.186-.585-.239-.692-.985-1.303-2.661-2.022-4.762-2.022-2.979 0-4.815 1.49-4.815 3.858 0 2.899 2.554 3.777 4.788 4.522 1.703.585 3.166 1.064 3.166 2.314 0 1.702-1.889 1.968-3.033 1.968-1.542 0-2.739-.479-3.724-1.436a1.08 1.08 0 0 0-.798-.346c-.585 0-1.064.479-1.064 1.064 0 .24.08.426.266.692.878 1.117 2.873 2.26 5.32 2.26 3.352 0 5.347-1.569 5.347-4.176 0-2.82-2.5-3.697-4.735-4.468"
      />
      <path
        fill="#9B65C3"
        d="M.775 28.89a13.7 13.7 0 0 0 3.83 7.607l4.655-4.655c0-4.708 2.447-9.284 6.81-11.81z"
      />
      <path
        fill="#9B65C3"
        d="M9.26 31.843c-2.314 0-4.655-.586-6.81-1.836a14 14 0 0 1-1.675-1.144 13.7 13.7 0 0 0 3.83 7.608z"
      />
      <path
        fill="#BE63C5"
        d="m9.26 31.842-4.655 4.655a13.46 13.46 0 0 0 7.607 3.83l8.832-15.295c-2.5 4.363-7.076 6.81-11.784 6.81"
      />
      <path
        fill="#BF63C6"
        d="M11.095 38.678a13.5 13.5 0 0 1-1.835-6.81l-4.655 4.655a13.46 13.46 0 0 0 7.607 3.83 18 18 0 0 1-1.117-1.675"
      />
      <path
        fill="#3278B1"
        d="m26.604 13.966-10.507 6.091c-4.363 2.527-9.55 2.341-13.62 0A13.45 13.45 0 0 0 .801 28.89c.532.425 1.091.797 1.676 1.143a13.5 13.5 0 0 0 6.81 1.836l17.61-17.61c-.107-.106-.187-.212-.293-.292"
      />
      <path
        fill="#3278B2"
        d="M2.45 30.034a13.5 13.5 0 0 0 6.81 1.835c0-4.708 2.447-9.283 6.81-11.81L.748 28.889c.558.4 1.117.799 1.702 1.145"
      />
      <path
        fill="#45A4EC"
        d="M2.45 20.059a13.45 13.45 0 0 0-1.675 8.83l15.321-8.83a13.73 13.73 0 0 1-13.646 0"
      />
      <path
        fill="#19BB7D"
        d="M26.896 14.233c-.08-.08-.186-.187-.293-.267a2.4 2.4 0 0 0-.425-.292 3.4 3.4 0 0 0-1.703-.452H14.261c-5.054 0-9.443 2.74-11.81 6.81 4.07 2.34 9.256 2.526 13.619 0a13.64 13.64 0 0 0-6.81 11.81c4.708 0 9.284-2.447 11.81-6.81l6.065-10.507c-.08-.106-.16-.213-.24-.293"
      />
      <path
        fill="#08C7FB"
        d="m16.096 20.058 10.507-6.065a2.4 2.4 0 0 0-.425-.293L2.45 20.058c4.07 2.34 9.257 2.5 13.646 0"
      />
      <path
        fill="#59F2F6"
        d="M24.475 13.222H14.261c-5.054 0-9.443 2.74-11.81 6.81l23.727-6.358c-.506-.266-1.064-.452-1.703-.452"
      />
      <path
        fill="#DA3757"
        d="m21.07 25.032 6.065-10.507c-.08-.106-.16-.186-.266-.293L9.26 31.842c0 2.314.586 4.655 1.836 6.81.346.585.719 1.143 1.144 1.675.665.107 1.33.16 2.022.16 2.474 0 4.814-.665 6.81-1.836-2.341-4.07-2.528-9.257 0-13.619"
      />
      <path
        fill="#D33C4E"
        d="M9.26 31.842c0 2.314.585 4.655 1.835 6.81.346.585.719 1.143 1.144 1.675l8.831-15.295a13.64 13.64 0 0 1-11.81 6.81"
      />
      <path
        fill="#EE5A24"
        d="m21.07 25.032-8.83 15.322c.664.106 1.33.16 2.021.16 2.474 0 4.815-.666 6.81-1.836-2.341-4.096-2.527-9.283 0-13.646"
      />
      <path
        fill="#8BDF55"
        d="M27.428 14.95a2.4 2.4 0 0 0-.293-.426c-.08-.106-.16-.186-.266-.292a3 3 0 0 0-.292-.266l-10.48 6.091a13.64 13.64 0 0 0-6.81 11.81c4.708 0 9.283-2.447 11.81-6.809-2.527 4.363-2.34 9.55 0 13.62 4.07-2.368 6.81-6.757 6.81-11.811V16.652c-.027-.638-.186-1.223-.479-1.702"
      />
      <path
        fill="#25C16F"
        d="m26.604 13.966-10.508 6.091a13.64 13.64 0 0 0-6.81 11.81l17.61-17.609c-.106-.106-.186-.212-.293-.292"
      />
      <path
        fill="#8BDF55"
        d="M9.26 31.842c4.708 0 9.283-2.447 11.81-6.81l6.065-10.507c-.08-.106-.16-.186-.266-.293z"
      />
      <path
        fill="#FB0"
        d="M27.135 14.525 21.07 25.032c-2.527 4.363-2.34 9.55 0 13.62l6.358-23.728a4 4 0 0 0-.293-.399"
      />
      <path
        fill="#FFA800"
        d="M21.07 38.679c4.07-2.368 6.81-6.757 6.81-11.811V16.654c0-.612-.16-1.197-.453-1.703z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Freshworks_svg__a">
        <path
          fill="#fff"
          d="M.615 0h160v48h-160z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoFreshworks;
